import { useEffect } from 'react';

import { FormGroup } from '@/components/FormGroup';
import { stepStore } from '@/stores/steps';

import Details from './Details';

const UploadFile = () => {
  useEffect(() => {
    stepStore.getState().removeStepsAhead('product_details_ai_loading_examples');
    stepStore.getState().removeStepsAhead();
  }, []);

  return (
    <FormGroup collapsable={false} showValidationState={false} reviewMode={false}>
      <Details />
    </FormGroup>
  );
};

export default UploadFile;
